<template>
  <transactions-table
    :is-payoutsRegistries-loading="isPayoutsRegistriesLoading"
    class="payouts-registries-table"
    grid-template-columns="82px 200px 1fr 1.1fr 1.3fr 60px"
  >
    <template #tableHeader>
      <transactions-table-header
        class="transactions-table__header"
        :header-cols="$options.HEADER_COLS"
        @sortChanged="handleSortChanged"
      ></transactions-table-header>
    </template>
    <template #transactionItems>
      <payouts-registry-table-item
        :payouts-registry="registry"
        v-for="registry in payoutsRegistriesPaged"
        :key="registry.id"
        @deleted="handleRegistryDeleted"
        @click="handlePayoutsRegistryItemClicked"
      ></payouts-registry-table-item>
    </template>
    <template #tablePagination>
      <transactions-table-pagination
        @changePage="handlePageChanged"
        :current-page="currentPage"
        :items-count="payoutsRegistriesFiltered.length"
        :per-page="perPage"
      ></transactions-table-pagination>
    </template>
  </transactions-table>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../../utils/gogocodeTransfer'
import TransactionsTable from '@vue-app/components/company/transactions/table/TransactionsTable.vue'
import TransactionsTableHeader from '@vue-app/components/company/transactions/table/TransactionsTableHeader.vue'
import TransactionsTableItem from '@vue-app/components/company/transactions/table/TransactionsTableItem.vue'
import TransactionsTablePagination from '@vue-app/components/company/transactions/table/TransactionsTablePagination.vue'
import PayoutsToCardTableItem from '@vue-app/components/company/payouts/to-card/table/item/PayoutsToCardTableItem.vue'
import PayoutsRegistryTableItem from '@vue-app/components/company/payouts/by-registry/table/item/PayoutsRegistryTableItem.vue'
import PayoutsRegistry from '@js-app/entities/payouts/PayoutsRegistry'
import { mapState } from 'vuex'
import moment from 'moment/moment'

export default {
  name: 'PayoutsRegistriesTable',
  components: {
    PayoutsRegistryTableItem,
    PayoutsToCardTableItem,
    TransactionsTablePagination,
    TransactionsTableItem,
    TransactionsTableHeader,
    TransactionsTable,
  },
  props: {
    payoutsRegistriesList: {
      type: Array,
      default() {
        return []
      },
    },
    isPayoutsRegistriesLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    currentPage: 1,
    perPage: 10,
    sort: {
      col: null,
      dir: null,
    },
  }),
  HEADER_COLS: [
    {
      id: 'date',
      hasSort: true,
      sortKey: 'date',
      title: 'payouts.by-registry.table.column.date',
      additionalClasses: ['transactions-table-header__col--date'],
    },
    {
      id: 'name',
      hasSort: true,
      sortKey: 'name',
      title: 'payouts.by-registry.table.column.name',
      additionalClasses: ['transactions-table-header__col--name'],
    },
    {
      id: 'payoutsCount',
      hasSort: true,
      sortKey: 'payoutsCount',
      title: 'payouts.by-registry.table.column.payouts-count',
      additionalClasses: ['transactions-table-header__col--p-count'],
    },
    {
      id: 'payoutsSum',
      hasSort: true,
      sortKey: 'payoutsSum',
      title: 'payouts.by-registry.table.column.payouts-sum',
      additionalClasses: ['transactions-table-header__col--p-sum'],
    },
    {
      id: 'status',
      hasSort: true,
      sortKey: 'status',
      title: 'payouts.by-registry.table.column.status',
      additionalClasses: ['transactions-table-header__col--status'],
    },
    {
      id: 'action',
      hasSort: false,
      title: 'payouts.by-registry.table.column.action',
      additionalClasses: ['transactions-table-header__col--action'],
    },
  ],
  watch: {
    payoutsRegistriesFiltered() {
      this.currentPage = 1
    },
  },
  computed: {
    ...mapState(['selectedCompany']),
    payoutsRegistriesPaged() {
      let _startFrom = (this.currentPage - 1) * this.perPage
      return this.payoutsRegistriesFiltered.slice(
        _startFrom,
        _startFrom + this.perPage
      )
    },
    payoutsRegistriesFiltered() {
      return [...this.payoutsRegistriesSorted]
    },
    payoutsRegistriesSorted() {
      if (!this.sort || !this.sort.col) {
        return this.payoutsRegistries
      }

      return [...this.payoutsRegistries].sort(
        (fPayoutsRegistry, sPayoutsRegistry) => {
          let _firstGrater = false

          switch (this.sort.col) {
            case 'date': {
              let _firstDate = moment(fPayoutsRegistry.datePlain)
              let _secondDate = moment(sPayoutsRegistry.datePlain)

              if (_firstDate > _secondDate) {
                _firstGrater = true
              }
              break
            }
            case 'name': {
              if (
                fPayoutsRegistry.registryName > sPayoutsRegistry.registryName
              ) {
                _firstGrater = true
              }

              break
            }
            case 'payoutsCount': {
              if (fPayoutsRegistry.totalCount > sPayoutsRegistry.totalCount) {
                _firstGrater = true
              }

              break
            }
            case 'payoutsSum': {
              if (
                parseInt(fPayoutsRegistry.totalSumPlain) >
                parseInt(sPayoutsRegistry.totalSumPlain)
              ) {
                _firstGrater = true
              }

              break
            }
            case 'status': {
              if (
                parseInt(fPayoutsRegistry.status) >
                parseInt(sPayoutsRegistry.status)
              ) {
                _firstGrater = true
              }

              break
            }
          }

          switch (this.sort.dir) {
            case 'DESC': {
              if (_firstGrater) {
                return -1
              } else {
                return 1
              }
            }
            case 'ASC': {
              if (_firstGrater) {
                return 1
              } else {
                return -1
              }
            }
          }
        }
      )
    },
    payoutsRegistries() {
      return this.payoutsRegistriesList.map(
        (_transObject) => new PayoutsRegistry(_transObject)
      )
    },
  },
  methods: {
    handlePayoutsRegistryItemClicked(payoutsRegistryId) {
      this.$router.push({
        name: 'payouts-registry',
        params: {
          id: this.selectedCompany,
          payoutsRegistryId,
        },
      })
    },
    handleRegistryDeleted(payoutsRegistry) {
      $emit(this, 'registryDeleted', payoutsRegistry)
    },
    handlePageChanged(page) {
      this.currentPage = page
    },
    handleSortChanged(newSort) {
      this.sort = { ...newSort }
    },
  },
  emits: ['registryDeleted'],
}
</script>

<style lang="scss" scoped>
.payouts-registries-table {
  max-width: 835px;
  :deep(.transactions-table) {
    .transactions-table__header {
      padding: 30px 10px;
      background: #ffffff;
      border-radius: 20px 20px 0 0;
      border-bottom: 1px solid #eff2f8;
    }

    .transactions-table__body {
      background: #ffffff;
      border-radius: 0 0 20px 20px;
      padding-bottom: 30px;
    }
  }

  :deep(.transactions-table-header) {
    .transactions-table-header__col {
      .transactions-table-header__col--name {
        justify-content: flex-start;
      }

      .transactions-table-header__col--p-sum,
      .transactions-table-header__col--p-count {
        justify-content: flex-end;
      }

      .transactions-table-header__col--status {
        justify-content: center;
      }

      .transactions-table-header__col--action {
        justify-content: center;
      }
    }
  }
}
</style>
